"use client"

import { useCallback } from "react"
import { getMessageHistoryOnce } from "../lib/messageHistoryClient"
import { groupMessagesIntoConversations } from "../lib/chatUtils"

interface UseUserHistoryProps {
  myUsers: any[]
  session: any
  updateUsersWithHistory: React.Dispatch<React.SetStateAction<Set<string>>>
  dateFilter?: { mode: "single" | "range"; from?: string; to?: string }
  updateConversationCounts?: React.Dispatch<React.SetStateAction<{ [phone: string]: number }>>
}

export const useUserHistory = ({ myUsers, session, updateUsersWithHistory, dateFilter, updateConversationCounts }: UseUserHistoryProps) => {
  const checkIfUserHasHistoryAndUpdate = useCallback(
    async (userId: number) => {
      const user = myUsers.find((u) => u.id === userId)
      if (!user) return

      try {
        let fetchParams: any = {
          phone: user.phone,
          session,
          userId: userId, 
        }

        if (dateFilter && (dateFilter.from || dateFilter.to)) {
          if (dateFilter.mode === "single" && dateFilter.from) {
            fetchParams.from = dateFilter.from;
            fetchParams.to = dateFilter.from;
          } else if (dateFilter.mode === "range") {
            if (dateFilter.from) fetchParams.from = dateFilter.from;
            if (dateFilter.to) fetchParams.to = dateFilter.to;
          }
        }

        const data = await getMessageHistoryOnce(fetchParams);
        
        const conversations = groupMessagesIntoConversations(data);
        
        if (updateConversationCounts && data && data.length > 0) {
          updateConversationCounts((prev) => ({
            ...prev,
            [user.phone]: conversations.length,
          }));
        }
        
        updateUsersWithHistory((prev) => {
          const updated = new Set(prev)
          if (data.length > 0) {
            updated.add(String(userId))
          } else {
            updated.delete(String(userId))
          }
          return updated
        })
      } catch (error) {
        console.error("Error checking history for user:", error)
      }
    },
    [myUsers, session, updateUsersWithHistory, dateFilter, updateConversationCounts],
  )

  return { 
    checkIfUserHasHistoryAndUpdate,
  }
}
